import { useTranslation } from "react-i18next";

export const chartCategories = {
  yes: { background: "#00492C", color: "white" },
  a_bit: { background: "#B1D8B8", color: "black" },
  not_so_much: { background: "#FDE2D1", color: "black" },
  no: { background: "#E14D26", color: "black" },
  dont_know: { background: "#aaaaaa", color: "black" },
};

export const getChartColors = (category: any) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return chartCategories[category];
};

function LegendChart() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row flex-wrap items-center gap-6">
      {Object.entries(chartCategories).map(([cat, _]) => (
        <div key={`legend-${cat}`} className="flex flex-row items-center gap-2">
          <div
            className="rounded-lg w-8 h-2"
            style={{ backgroundColor: getChartColors(cat).background }}
          />

          <span>{t(`balanceChartLabels.${cat}`)}</span>
        </div>
      ))}
    </div>
  );
}

export default LegendChart;
